import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ActionType } from "../constants/actionType";
import { EventType } from "../constants/eventType";
import { UserStatus } from "../constants/userStatus";
var resolveLoggedIn = function resolveLoggedIn(_ref) {
  var qffHashId = _ref.qffHashId,
    isLoggedIn = _ref.isLoggedIn;
  if (isLoggedIn && qffHashId) {
    return UserStatus.LOGGED_IN;
  }
  return UserStatus.LOGGED_OUT;
};
var buildUser = function buildUser(_ref2) {
  var _ref2$qffHashId = _ref2.qffHashId,
    qffHashId = _ref2$qffHashId === void 0 ? "" : _ref2$qffHashId,
    _ref2$isLoggedIn = _ref2.isLoggedIn,
    isLoggedIn = _ref2$isLoggedIn === void 0 ? false : _ref2$isLoggedIn;
  return {
    user_qff_hash: qffHashId,
    user_login_status: resolveLoggedIn({
      qffHashId: qffHashId,
      isLoggedIn: isLoggedIn
    })
  };
};
export var pageViewEvent = function pageViewEvent(_ref3) {
  var qffHashId = _ref3.qffHashId,
    isLoggedIn = _ref3.isLoggedIn,
    pathName = _ref3.pathName;
  var eventData = {
    event_data: {
      action: ActionType.VIEW
    },
    content: {
      page_location: pathName
    },
    user: buildUser({
      qffHashId: qffHashId,
      isLoggedIn: isLoggedIn
    })
  };
  var event = _objectSpread({
    event: EventType.PAGE_VIEW
  }, eventData);
  return event;
};